var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"orgao-regional","rota-base":"/admin/orgao-regional","titulo":"ÓRGÃOS REGIONAIS","titulo-singular":"Órgão Regional","colunas-extras":[{"campo":"sigla","label":"Sigla","tipo":"string","maxLength":20},{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":20}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }